<script setup lang="ts">

import type { BookingViewModel } from "../BookingViewModel";

const model = defineModel<BookingViewModel>( { required: true } );

</script>

<template>

    <div>
        <pre>{{ model }}</pre>
    </div>

</template>